//app信息接口
export const BASE_URL = 'https://utils.zydl-tec.cn';
export const DEV_BASE_URL = 'https://utils.zydl-tec.cn'

export const DOWN_INFO = '/publish/installinfo';
